module.exports = __webpack_public_path__ + "static/media/Square_Roots_Next-Gen_Farmer_Transplanting_Basil.crop.7c6214a7.jpg";